export const SITE_TEXTS_GRID_NAME = 'SiteTextsGrid';

export const SITE_TEXTS_SECTION__COMMON = 'common';
export const SITE_TEXTS_SECTION__MENU = 'menu';
export const SITE_TEXTS_SECTION__CUSTOM = 'custom';

export const siteTextsSectionLangKeys = {
  [SITE_TEXTS_SECTION__COMMON]: 'header.site.texts-common',
  [SITE_TEXTS_SECTION__MENU]: 'header.site.texts-menu',
  [SITE_TEXTS_SECTION__CUSTOM]: 'header.site.texts-custom',
};

const SITE_TEXT_LANGKEY__BOYS_WELCOME_SUBTYPE = 'header.rivboys.welcome.subtitle';
const SITE_TEXT_LANGKEY__BOYS_WELCOME_TEXT = 'header.rivboys.welcome.text';
const SITE_TEXT_LANGKEY__BOYS_WELCOME_TITLE = 'header.rivboys.welcome.title';
const SITE_TEXT_LANGKEY__TOP_MODELS_TITLE = 'header.webmaster.content_items';
const SITE_TEXT_LANGKEY__WELCOME_TITLE = 'headwelcome';
const SITE_TEXT_LANGKEY__MENU_BECOME_MODEL = 'menu.becomemodel';
const SITE_TEXT_LANGKEY__MENU_CONTACT = 'menu.contact';
const SITE_TEXT_LANGKEY__MENU_HELP = 'menu.help';
const SITE_TEXT_LANGKEY__MENU_HOME = 'menu.home';
const SITE_TEXT_LANGKEY__MENU_SEARCH = 'menu.search';
const SITE_TEXT_LANGKEY__MENU_SIGNUP = 'menu.signup';
const SITE_TEXT_LANGKEY__MENU_WEBCHAT = 'menu.webchat';
const SITE_TEXT_LANGKEY__MENU_INTERVIEWS = 'menuinterviews';
const SITE_TEXT_LANGKEY__MENU_PRODUCTS = 'menuproducts';
const SITE_TEXT_LANGKEY__WELCOME_TEXT = 'msg.welcome';
const SITE_TEXT_LANGKEY__FETISH_WELCOME_HEADER = 'webmaster.fetish.welcome.header';
const SITE_TEXT_LANGKEY__FETISH_WELCOME_SUBHEADER = 'webmaster.fetish.welcome.subheader';
const SITE_TEXT_LANGKEY__FETISH_WELCOME_TEXT = 'webmaster.fetish.welcome.text';

export const siteTextLangKeyToTranslatedLangKeyMap = {
  [SITE_TEXT_LANGKEY__BOYS_WELCOME_SUBTYPE]: 'msg.rivboys-welcome.subtitle',
  [SITE_TEXT_LANGKEY__BOYS_WELCOME_TEXT]: 'msg.rivboys-welcome.text',
  [SITE_TEXT_LANGKEY__BOYS_WELCOME_TITLE]: 'msg.rivboys-welcome.title',
  [SITE_TEXT_LANGKEY__TOP_MODELS_TITLE]: 'msg.header.top-models',
  [SITE_TEXT_LANGKEY__WELCOME_TITLE]: 'msg.welcome.title',
  [SITE_TEXT_LANGKEY__MENU_BECOME_MODEL]: 'msg.wl-menu.become-model',
  [SITE_TEXT_LANGKEY__MENU_CONTACT]: 'msg.wl-menu.contact',
  [SITE_TEXT_LANGKEY__MENU_HELP]: 'msg.wl-menu.help',
  [SITE_TEXT_LANGKEY__MENU_HOME]: 'msg.wl-menu.home',
  [SITE_TEXT_LANGKEY__MENU_SEARCH]: 'msg.wl-menu.search',
  [SITE_TEXT_LANGKEY__MENU_SIGNUP]: 'msg.wl-menu.signup',
  [SITE_TEXT_LANGKEY__MENU_WEBCHAT]: 'msg.wl-menu.webchat',
  [SITE_TEXT_LANGKEY__MENU_INTERVIEWS]: 'msg.wl-menu.interviews',
  [SITE_TEXT_LANGKEY__MENU_PRODUCTS]: 'msg.wl-menu.products',
  [SITE_TEXT_LANGKEY__WELCOME_TEXT]: 'msg.wl-text.welcome-text',
  [SITE_TEXT_LANGKEY__FETISH_WELCOME_HEADER]: 'msg.wl-text.fetish-welcome-header',
  [SITE_TEXT_LANGKEY__FETISH_WELCOME_SUBHEADER]: 'msg.wl-text.fetish-welcome-subheader',
  [SITE_TEXT_LANGKEY__FETISH_WELCOME_TEXT]: 'msg.wl-text.fetish-welcome-text',
};

export const TRANSLATION_STATUS__ACTIVE = 'APPROVED';
export const TRANSLATION_STATUS__PENDING = 'PENDING';
export const TRANSLATION_STATUS__CANCELED = 'CANCELED';

export const translationStatuses = [
  TRANSLATION_STATUS__ACTIVE,
  TRANSLATION_STATUS__PENDING,
  TRANSLATION_STATUS__CANCELED,
];

export const translationStatusLangKeys = {
  [TRANSLATION_STATUS__ACTIVE]: 'msg.active',
  [TRANSLATION_STATUS__PENDING]: 'msg.pending',
  [TRANSLATION_STATUS__CANCELED]: 'msg.canceled',
};
